
import { FaCalculator } from "react-icons/fa6";
import { FaTools } from "react-icons/fa";
import { SlCalender } from "react-icons/sl";
import { FaHandHoldingUsd } from "react-icons/fa";

const data = [
  {
    id: 1,
    icon: <FaCalculator />,
    title: 'Konsultasi & Estimasi',
    desc: 'Pilih jenis service sesuai kebutuhan perangkat Apple Anda dan dapatkan estimasi biaya secara cepat, jelas, dan transparan.',
  },
  {
    id: 2,
    icon: <SlCalender />,
    title: 'Penjadwalan Service',
    desc: 'Tentukan jadwal serta lokasi servis dengan praktis sesuai kebutuhan dan kenyamanan Anda, sehingga proses layanan menjadi lebih mudah dan efisien.',
  },
  {
    id: 3,
    icon: <FaTools />,
    title: 'Proses Perbaikan',
    desc: 'Perangkat Apple Anda akan ditangani langsung oleh teknisi berpengalaman dengan proses pengerjaan yang aman dan profesional.',
  },
  {
    id: 4,
    icon: <FaHandHoldingUsd />,
    title: 'Pembayaran Mudah dan Aman',
    desc: 'Lakukan pembayaran dengan mudah dan aman setelah proses service selesai, dengan metode pembayaran yang praktis dan nyaman untuk Anda.',
  },
];

export default data;
